import React from 'react';
import { useLocation } from 'react-router';
import { toastService } from 'components/molecules/toast';
import { useTranslate } from 'hooks/use-translation';
import { useCreateFieldMutation } from 'queries';
import { IntervalFormPage } from './interval-form-page';

export const NewIntervalPage = ({ title, objectType, onClose }) => {
  const translate = useTranslate();

  const { state } =
    useLocation<{ startKeyEventId: number; endKeyEventId: number }>();

  const mutation = useCreateFieldMutation({
    onSuccess: (res) => {
      toastService({
        title: translate('settings.intervals.create.success.title'),
        message: translate('settings.intervals.create.success.message', {
          fieldLabel: res ? res.fieldLabel : '',
        }),
      }).success();
    },
  });

  return (
    <IntervalFormPage
      onClose={onClose}
      title={title}
      objectType={objectType}
      mutation={mutation}
      field={{
        fieldLabel: '',
        description: '',
        metaData: {
          startKeyEventId: state?.startKeyEventId,
          endKeyEventId: state?.endKeyEventId,
        },
      }}
    />
  );
};
